import { portalJson } from '../lib/portalApi';

export type AdminFacilityType = 'apt' | 'shop' | 'office' | 'public' | 'etc';

export type AdminInstallCase = {
  id: number;
  title: string;
  facility_type: string;
  region: string;
  charger_count: string;
  install_type: string;
  summary: string;
  description: string;
  main_image_url: string;
  image_1_url: string;
  image_2_url: string;
  image_3_url: string;
  is_published: boolean;
  is_pinned: boolean;
  sort_order: number;
  created_at?: string | null;
  updated_at?: string | null;
  published_at?: string | null;
};

export type AdminInstallCaseInput = {
  title: string;
  facility_type: AdminFacilityType;
  region: string;
  charger_count: string;
  install_type: string;
  summary: string;
  description: string;
  main_image_url: string;
  image_1_url: string;
  image_2_url: string;
  image_3_url: string;
  is_published: boolean;
  is_pinned: boolean;
  sort_order: number;
};

const BASE = '/api/admin/ev123/install-cases';

function listUrl(params: { facility_type?: string; q?: string }): string {
  const sp = new URLSearchParams();
  if (params.facility_type && params.facility_type !== 'all') sp.set('facility_type', params.facility_type);
  if (params.q?.trim()) sp.set('q', params.q.trim());
  const qs = sp.toString();
  return qs ? `${BASE}?${qs}` : BASE;
}

export async function listAdminInstallCases(params: { facility_type?: string; q?: string }) {
  const r = await portalJson<AdminInstallCase[]>(listUrl(params), { auth: true });
  if (!r.ok) return r;
  return { ok: true as const, data: Array.isArray(r.data) ? r.data : [] };
}

export async function createAdminInstallCase(body: AdminInstallCaseInput) {
  return portalJson<AdminInstallCase>(BASE, {
    method: 'POST',
    auth: true,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function updateAdminInstallCase(id: number, body: AdminInstallCaseInput) {
  return portalJson<AdminInstallCase>(`${BASE}/${id}`, {
    method: 'PUT',
    auth: true,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function deleteAdminInstallCase(id: number) {
  return portalJson<unknown>(`${BASE}/${id}`, { method: 'DELETE', auth: true });
}

export async function patchAdminInstallCasePublish(id: number, is_published: boolean) {
  return portalJson<AdminInstallCase>(`${BASE}/${id}/publish`, {
    method: 'PATCH',
    auth: true,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ is_published }),
  });
}

export async function patchAdminInstallCasePin(id: number, is_pinned: boolean) {
  return portalJson<AdminInstallCase>(`${BASE}/${id}/pin`, {
    method: 'PATCH',
    auth: true,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ is_pinned }),
  });
}
